import React from "react";
import { Link } from "react-router-dom";
import "./Contact.scss";
import contactImg from '../../assets/img/contact.jpg';
import CommonButton from "../components/CommonButton";

const contactText = {
  title: "Ready to discuss your project?",
  description: "We will guide you towards the best solution for your space."
};

export const Contact = () => {
  return (
    <section className="contact-section">
      <div className="contact">
        
        <div className="contact__content">
          <h1 className="contact__title">{contactText.title}</h1>
          <p className="contact__description">{contactText.description}</p>
          <Link to="/contact">
            <CommonButton presetStyle='dark' customClass='contact__button' size='large'>
              Get Started
            </CommonButton>
          </Link>
        </div>
        <div className="contact__image">
          <img src={contactImg} alt={`${contactText.title} - ${contactText.name}`} />
        </div>
      </div>
    </section>
  );
};

export default Contact;